module.exports = __webpack_public_path__ + "static/img/RSG64_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSG64_1.png
// module id = /LG7
// module chunks = 0